import React ,{useState , useEffect} from "react";

export default function TermsPopup({ data, setisCondition }) {
  const [termsData, settermsData] = useState();
  useEffect(()=>{

    if(data == "privacy"){
      settermsData(PrivacyData.replace(/\n/g, "<br />").replace(/\n\n/g, "</p><p>"));
    }else{
      settermsData(TermsData.replace(/\n/g, "<br />").replace(/\n\n/g, "</p><p>"));
    }
  },[data])


  const TermsData = 
  `<div class = "header-terms">Terms and Conditions</div>
  These Terms of Use (“Terms”) govern your use of askmntor AI. (“askmntor AI”, “we”, “us”) products and services including our website and conversational AIs (“Services”).
  
  These Terms incorporate by reference our Privacy Policy, as well as any other written policies and documentation that we may provide from time to time. You agree to use our Services in compliance with these Terms.
  
  Your use of our Services in any manner means that you agree to the Terms. Unfortunately, if you do not agree with these Terms, you may not access or use our Services.
  
  Our Services
  askmntor AI is designed to transform how we engage with educational content, making learning more interactive, collaborative, and enjoyable. As you use our Services, we continuously improve to ensure they are as helpful and effective as possible for your UPSC preparation journey.
  
  Key Points:
  Improvement Through Interaction: Conversations and metadata are used to refine and enhance our models and Services, as outlined in our Privacy Policy.
  Responsible Usage: By using our Services, you agree to adhere to our Acceptable Use Policy.
  Accuracy Disclaimer: Information provided may not always be accurate. Verify details independently or consult experts before relying on the content.
  
  Registering for Our Services:
  Registration Requirements: Provide accurate details, including your name and phone number. Do not use a number you do not own or impersonate others.
  Organizational Access: If registering on behalf of an organization, ensure you are authorized to agree to these Terms.
  Account Responsibility: Safeguard your account to prevent unauthorized access.
  Age Restriction: Our Services are for individuals aged 18 and above. If you are under 18, do not register or share personal information with us.
  
  Acceptable Use Policy
  
  When using askmntor AI for educational purposes, especially for UPSC preparation, you agree to the following:
  
  Legal Compliance: Use our Services in accordance with applicable laws.
  No Harmful Content: Avoid generating or attempting to generate content that promotes harm, unethical behavior, or misinformation. Content falsely represented as human-generated is also prohibited.
  Respectful Content: Do not create hateful, discriminatory, sexually explicit, or violent material.
  Privacy and Rights: Respect the privacy and rights of others. Do not seek or share personal or sensitive information about individuals.
  Maintain Security: Avoid actions that disable, disrupt, or bypass security and content moderation systems.
  No Reverse Engineering: Do not attempt to reverse engineer, decompile, or replicate the underlying technology or models.
  No Scraping: Do not scrape or extract data from our Services using manual or automated methods.
  By adhering to these guidelines, you help maintain a safe and effective environment for UPSC-focused learning.
  
  Content Usage
  When using askmntor AI for educational purposes, including UPSC preparation, you agree to:
  
  Ownership and Permissions: Only input text or media you own or have permission to use.
  License Grant: While you retain ownership of your input, you provide askmntor AI with a royalty-free, perpetual, worldwide license to:
  Operate the Services: Process and manage your input to deliver and maintain the Services.
  Improve the Services: Analyze and use your input to enhance current features and develop new tools.
  For more details, please review our Privacy Policy.
  
  Account Termination
  askmntor AI reserves the right to suspend or terminate your account for reasons such as:
  
  Violation of these Terms.
  Ensuring user safety or legal compliance.
  Protecting the rights or property of askmntor AI.
  You can request account deletion by contacting support@askmntor.com, with verification required for security reasons. Certain terms, like indemnification and liability limitations, will survive termination.
  
  Service Changes
  askmntor AI is constantly evolving, and Services may change, be updated, or discontinued. We aim to provide advance notice when possible but cannot guarantee this in all cases.
  
  Terms Updates
  Terms may be updated periodically. Continued use of the Services after updates signifies your acceptance of the changes. If you disagree, you must stop using the Services immediately.
  
  Stay informed by regularly reviewing the Terms on our website.`;
  
  const PrivacyData = 
  `<div class = "header-terms">Privacy Snapshot</div>
  askmntor AI prioritizes your privacy and ensures transparency in how we handle your data when you use our Services for educational purposes, including UPSC preparation.
  
  Key Points:
  Data Collection: We collect data like your name, phone number, and IP address to operate and improve our platform, ensure user safety, and comply with legal requirements.
  Data Privacy: Your data is secure and will never be sold or shared for advertising or marketing purposes. Strict internal controls limit access and usage of your data.
  Acceptable Use: Adhere to our policy by avoiding harmful, abusive, or illegal topics. Attempts to bypass security measures or explore the underlying technology are prohibited and may lead to suspension.
  Age Restriction: Only individuals aged 18 and above can use askmntor AI.
  Content Accuracy: The platform may provide inaccurate information. Always verify facts independently or consult a professional for critical advice.
  This Privacy Policy underscores our commitment to building a safe, intelligent, and user-focused platform to support your learning journey.
  
  Information We Collect
  
  askmntor AI collects data to enhance your educational experience, particularly for UPSC preparation.
  
  Data You Provide:
  Contact Information: First and last name, email address, and phone number.
  Content: Messages sent through our platform and communications with askmntor AI.
  Feedback: Responses to surveys or queries.
  Additional Data: Any other data shared will be used as described in our Privacy Policy.
  Data Collected Automatically:
  Device Information: Details like operating system, browser, IP address, screen resolution, and device type.
  Activity Logs: Pages viewed, time spent, navigation paths, and interaction with our communications.
  Tracking Tools:
  Cookies: To remember preferences and enhance navigation.
  Local Storage: For additional storage outside the browser.
  Web Beacons: To track content engagement.
  Data from Other Sources:
  Interactions through third-party platforms like Google or Facebook Messenger may include your profile identifier.
  Sensitive Data:
  You may share sensitive information (e.g., religious or political views, health details) during conversations. By doing so, you consent to its use for purposes outlined in our Privacy Policy.
  
  We collect and manage this data responsibly to improve our Services and make your learning journey effective and secure.
  
  
  
  How We Use Your Information
  
  We use your personal information to provide and improve our educational services tailored to UPSC preparation.
  
  Delivering Services:
  
  Operate, maintain, and fulfill our obligations under the Terms of Service.
  Ensure seamless use of our platform and tools.
  Communication:
  
  Respond to your queries and requests.
  Share updates, announcements, reminders, and administrative messages about our services.
  Enhancing and Securing Services:
  
  Personalize your learning experience based on your needs and interests.
  Monitor, troubleshoot, and secure the platform.
  Prevent, investigate, and protect against fraudulent or harmful activities.
  Research and Development:
  
  Improve our services using anonymized data to understand user behavior and enhance features.
  Share anonymized insights with third parties to improve and promote our offerings.
  Legal Compliance and Protection:
  
  Protect rights, privacy, safety, and property.
  Fulfill legal obligations, respond to government requests, and prevent unethical or illegal activities.
  Sharing Your Information
  
  No Sale of Data:
  
  We do not sell or share personal information for advertising purposes.
  Service Providers:
  
  Work with trusted third-party providers (e.g., hosting, maintenance, security) to manage and improve services.
  Business Transfers:
  
  Transfer data in case of business mergers, acquisitions, or changes in ownership.
  Legal and Regulatory Compliance:
  
  Share data with authorities if required by law or for protecting legal rights.
  We prioritize data security and ensure your information is handled responsibly to create a safe and effective learning environment.
  
  
  
  Privacy Rights and Choices
  
  Delete Your Account:
  You can request to delete your account by contacting us through the details provided in the "How to Contact Us" section.
  
  Opt Out of SMS Messaging:
  
  To stop receiving text messages, reply with STOP to any message from us. This may limit certain features, like receiving one-time codes.
  To pause all non-essential messages while still receiving codes, reply with PAUSE.
  Cookies and Online Tracking:
  
  You can manage your preferences for third-party cookies as outlined in our Cookie Policy.
  Personal Information Requests:
  Depending on your location and interactions, you may:
  
  Access details of how your information is collected and used.
  Request a copy of your personal information in a portable format.
  Request corrections for inaccurate or outdated information.
  Ask for the deletion of data we no longer need.
  Withdraw consent for processing personal information where applicable.
  Object to or request restrictions on how your data is used.
  To make such requests, contact us as described in the "How to Contact Us" section. We may verify your identity and, if needed, your authority to act on someone’s behalf.
  
  Limits on Requests:
  In some cases, we may not fulfill requests if they:
  
  Infringe on others’ rights.
  Prevent us from delivering requested services.
  Conflict with legal or regulatory obligations.
  If unsatisfied with our response, you can file a complaint with your local data protection authority.
  
  We are committed to respecting your privacy rights while providing a seamless educational experience for UPSC aspirants.
  
  
  Security
  We prioritize the secure handling of your data to maintain trust and the integrity of our educational services. Measures include restricting access to sensitive information to authorized personnel and deidentifying data where possible. However, no security system is foolproof, and use of our services is at your own risk. You are responsible for managing access to your account and devices to prevent unauthorized access.
  
  Third-Party Websites and Content
  Our services may include links or content from third parties. We are not responsible for their terms, policies, or handling of your data. Any interaction with these third parties is solely at your discretion.
  
  Children
  Our services are designed for users aged 18 and above. We do not knowingly collect data from minors. If you suspect a minor under 18 is using our services or has shared personal information, contact us at privacy@askmntor.com to have the account and data removed.
  
  Retention
  We retain personal data only as long as necessary for its intended purpose, regulatory requirements, or until you withdraw consent. Retention periods depend on the sensitivity of the data and applicable laws.
  
  International Data Transfers
  Your data may be stored or processed in the United States or other countries that may have different data protection laws. By using our services, you consent to such transfers.
  
  Job Applicants
  If you apply for a role with us, we collect information like contact details, skills, and work history. This data is used to evaluate applications, comply with legal requirements, and improve our recruitment process.
  
  Policy Updates
  We may update this Privacy Policy as our services evolve. The latest version will always be posted on this page, and continued use of our services constitutes acceptance of any changes.
  
  How to Contact Us
  For questions or concerns about this Privacy Policy, contact us at privacy@askmntor.com.
  
  This concise version ensures clarity while remaining relevant for UPSC-focused educational services.`
  
  return (
    <div className="termsandcondition">
      <div className="loader-container">
        
        <div className="data-container">
        <div className="close-Image"><img className="" src="/assets/images/close.svg" onClick={()=>setisCondition(false)}></img></div>
        {/* <div className="header-terms">Terms and Conditions</div> */}
         <p dangerouslySetInnerHTML={{ __html: termsData }}></p>
        </div>
      </div>
    </div>
  );
}
